import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-bookmark',
  templateUrl: './admin-bookmark.component.html',
  styleUrls: ['./admin-bookmark.component.scss']
})
export class AdminBookmarkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
